export default {
  Email: '',
};
